// Мелкие иконки досье (пути из assets RD-149), функциональные компоненты без состояния.
import { h } from 'vue'

const svg = (size: number, children: ReturnType<typeof h>[], viewBox = '0 0 24 24') => h('svg', {
    width: size,
    height: size,
    viewBox,
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': 1.8,
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'aria-hidden': 'true',
    style: 'flex: none',
}, children)

export const LockIcon = () => svg(12, [h('rect', { x: 5, y: 11, width: 14, height: 10, rx: 2 }), h('path', { d: 'M8 11V7a4 4 0 0 1 8 0v4' })])

export const ChevronRightIcon = () => svg(14, [h('path', { d: 'M9 6l6 6-6 6' })])

export const PlusIcon = () => svg(14, [h('path', { d: 'M12 5v14M5 12h14' })])

export const CalendarIcon = () => svg(14, [h('rect', { x: 3, y: 5, width: 18, height: 16, rx: 2 }), h('path', { d: 'M3 10h18M8 3v4M16 3v4' })])

export const CloseIcon = () => svg(16, [h('path', { d: 'M6 6l12 12M18 6L6 18' })])

export const BackIcon = () => h('svg', { width: 7, height: 11, viewBox: '0 0 9 13', fill: 'currentColor', 'aria-hidden': 'true' }, [
    h('path', { d: 'M3.37716 6.5002L8.12091 11.244L6.76583 12.599L0.666992 6.5002L6.76583 0.401367L8.12091 1.75645L3.37716 6.5002Z' }),
])
